var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightPointPendantHolder6Inch01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 7.8,
    cy: 8,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 7.8,
    y1: 3.3,
    x2: 7.8,
    y2: 12.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 3,
    y1: 8,
    x2: 13,
    y2: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPointPendantHolder6Inch01);
export default __webpack_public_path__ + "static/media/LightPoint-PendantHolder6Inch-01.80f4c6104ab7d910937df526e38133cd.svg";
export { ForwardRef as ReactComponent };